import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-top-grid">
            <div className="footer-column footer-brand-column">
              <div className="footer-logo-lockup">
                <div className="footer-logo-icon">
                  <svg
                    fill="none"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="4" y="2" rx="2" width="16" height="20"></rect>
                    <path d="M12 10h.01M12 14h.01M12 6h.01M16 10h.01M16 14h.01M16 6h.01M8 10h.01M8 14h.01M8 6h.01M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"></path>
                  </svg>
                </div>
                <span className="footer-brand-name">Stratix Group</span>
              </div>
              <p className="footer-description section-content">
                {' '}
                A vertically integrated construction organization overseeing
                elite general contracting and specialized trade divisions.
                Delivering institutional-grade excellence across residential,
                commercial, and government sectors.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-shorthand">
                <span className="footer-stx-badge">Skilled</span>
                <span className="footer-stx-badge">Trusted</span>
                <span className="footer-stx-badge">Execution</span>
              </div>
            </div>
            <div className="footer-column footer-nav-column">
              <h2 className="section-subtitle footer-heading">
                Corporate Navigation
              </h2>
              <nav className="footer-nav-list">
                <a href="Homepage">
                  <div className="footer-nav-link">
                    <span>Corporate Homepage</span>
                    <svg
                      fill="none"
                      width="16"
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                    </svg>
                  </div>
                </a>
                <a href="Divisions &amp; Services">
                  <div className="footer-nav-link">
                    <span>Operating Divisions</span>
                    <svg
                      fill="none"
                      width="16"
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                    </svg>
                  </div>
                </a>
                <a href="Contact &amp; Access">
                  <div className="footer-nav-link">
                    <span>Contact &amp; Compliance</span>
                    <svg
                      fill="none"
                      width="16"
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                    </svg>
                  </div>
                </a>
              </nav>
              <div className="footer-compliance-badges">
                <div className="footer-badge-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </svg>
                  <span>Licensed &amp; Insured</span>
                </div>
                <div className="footer-badge-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  </svg>
                  <span>OSHA Compliant</span>
                </div>
              </div>
            </div>
            <div className="footer-column footer-contact-column">
              <h2 className="section-subtitle footer-heading">
                Global Headquarters
              </h2>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <span className="footer-contact-label">Address</span>
                  <span className="footer-contact-value">
                    <span>1200 Industrial Parkway, Suite 400</span>
                    <br></br>
                    <span>Construction Heights, ST 90210</span>
                  </span>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-label">Inquiries</span>
                  <span className="footer-contact-value">
                    corporate@stratixgroup.com
                  </span>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-label">Telephone</span>
                  <span className="footer-contact-value">
                    +1 (800) 555-0198
                  </span>
                </div>
              </div>
              <div className="footer-social-row">
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-link">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                      <circle r="2" cx="4" cy="4"></circle>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Facebook" className="footer-social-link">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <div className="footer-legal-wrap">
              <p className="footer-copyright">
                © 2026 Stratix Group LLC. All Rights Reserved.
              </p>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Compliance Disclosure</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-stx-shorthand">
              <span className="footer-stx-text">STX</span>
              <span className="footer-stx-divider">|</span>
              <span className="footer-stx-tagline">
                Skilled • Trusted • Execution
              </span>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
  // No complex logic required for this static, professional footer.
  // The design relies on CSS transitions and semantic structure.
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
